import React, { useState, useEffect, useMemo } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  DialogTitle,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  TextField,
  Grid,
  IconButton,
  AppBar,
  Toolbar,
  Button,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack"; // Icono de retroceso
import { grey } from "@mui/material/colors";
import moment from "moment";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { UrlApiEnvasado } from "../../../../../services/apirest";
import { useLocation, useNavigate } from "react-router-dom";
import RefreshIcon from "@mui/icons-material/Refresh";
import DetalleFactura from "../../../DetalleFactura";
import { useFechas } from "../../../context/FechaContext";

function FacturacionSucursal(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    desdeButano,
    hastaButano,
    desdePropano,
    hastaPropano,
    setDesdeButano,
    setHastaButano,
    setDesdePropano,
    setHastaPropano,
  } = useFechas();
  const [loading, setLoading] = useState(false);
  const [facturas, setFacturas] = useState();
  const [desde, setDesde] = useState(
    location.state.tabla === "Butano" ? desdeButano : desdePropano
  );
  const [hasta, setHasta] = useState(
    location.state.tabla === "Butano" ? hastaButano : hastaPropano
  );

  useEffect(() => {
    if (location.state.tabla === "Butano") {
      setDesdeButano(desde);
      setHastaButano(hasta);
    } else {
      setDesdePropano(desde);
      setHastaPropano(hasta);
    }
  }, [desde, hasta]);

  const [origen, setOrigen] = useState("");
  useEffect(() => {
    if (location.state.row.origen === "bk1_aws_hipergas") {
      setOrigen("api/estadistica");
    } else if (location.state.row.origen === "bk1_aws_aogas") {
      setOrigen("db2/api/estadisticaaogas");
    }
  }, [location.state]);

  const fetchData = async () => {
    setLoading(true);
    try {
      fetch(
        `${UrlApiEnvasado}dbnet/api/estadisticanetizar/xsucursal/deudores/${desde} 00:00:00/${hasta} 23:59:59/${location.state.row.id_suc}`
      )
        .then((res) => res.json())
        .then((data) => {
          setFacturas(data);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // if (origen !== "") {
      fetchData();
    // }
  }, []);

  const handleUpdate = () => {
    fetchData();
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "name_cliente", //access nested data with dot notation
        header: "Facturado a",
        size: 115,
      },
      {
        accessorKey: "name_cliente_adi", //access nested data with dot notation
        header: "Cliente",
        size: 115,
      },
      {
        accessorKey: "detalles_resumen", //access nested data with dot notation
        header: "Detalles",
        size: 300,
      },
      {
        accessorKey: "ccd_fecha_mov", //access nested data with dot notation
        header: "Fecha",
        size: 100,
      },
      {
        accessorKey: "ccd_total", //access nested data with dot notation
        header: "Importe Total",
        size: 100,
        muiTableBodyCellProps: {
          align: "right",
        },
      },
    ],
    []
  );
  const customLocalization = {
    ...MRT_Localization_ES,
    expandAll: "Ex", // Cambia 'Expandir todo' a 'Ex'
    expand: "Ex", // Cambia 'Expandir' a 'Ex'
  };

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    size: "small",
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const initialState = {
    //para inicializar la tabla, y la cantidad de paginas q se ven ej 5
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };
  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: "#1F618D" }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" style={{ flexGrow: 1, textAlign: "center" }}>
            Facturación de {location.state.row.nombre_sucursal}
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ backgroundColor: "#fff", marginLeft: 1, marginRight: 1 }}>
        {/* Filtros */}
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="center"
          sx={{ mt: 0, mb: 1 }}
        >
          <Grid item xs={12} md={3}>
            <TextField
              label="Desde"
              type="date"
              value={desde}
              onChange={(e) => setDesde(e.target.value)}
              InputLabelProps={{ shrink: true }}
              size="small"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#1F618D" },
                  "&:hover fieldset": { borderColor: "#1F618D" },
                },
                "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1F618D !important",
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={3}>
            <TextField
              label="Hasta"
              type="date"
              value={hasta}
              onChange={(e) => setHasta(e.target.value)}
              InputLabelProps={{ shrink: true }}
              size="small"
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#1F618D" },
                  "&:hover fieldset": { borderColor: "#1F618D" },
                },
                "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#1F618D !important",
                },
              }}
            />
          </Grid>

          <Grid item xs={12} md={2}>
            <Button
              variant="contained"
              onClick={handleUpdate}
              disabled={loading}
              size="medium"
              fullWidth
              sx={{
                backgroundColor: "#1F618D",
                color: "#fff",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#154360",
                  transform: "translateY(-2px)",
                  boxShadow: "0 4px 8px rgba(31, 97, 141, 0.3)",
                },
                transition: "all 0.3s ease",
                height: "40px",
                borderRadius: "8px",
              }}
              startIcon={<RefreshIcon />}
            >
              {loading ? "Cargando..." : "Actualizar"}
            </Button>
          </Grid>
        </Grid>
        {loading ? (
          <Box display="flex" justifyContent="center" p={2}>
            <CircularProgress />
          </Box>
        ) : (
          <Box mt={0} mb={4}>
            <MaterialReactTable
              columns={columns}
              data={facturas ?? [{}]}
              layoutMode={"grid"}
              initialState={initialState}
              enableColumnActions={false} //deshabilita las acciones POR COLUMN}
              enableGlobalFilterModes={false}
              enableHiding={false}
              enableGrouping={true}
              enablePinning={true}
              enableColumnFilters={false}
              enableFullScreenToggle={false}
              positionActionsColumn={"last"}
              enableExpandAll={false}
              localization={customLocalization}
              enableToolbarInternalActions={true}
              muiTableHeadCellProps={tableHeadCellProps}
              muiSearchTextFieldProps={muiSearchTextFieldProps}
              enableDensityToggle={false}
              renderDetailPanel={({ row }) => (
                <DetalleFactura row={row.original} />
              )}
              enableColumnResizing={true}
              muiTableBodyCellProps={({ row }) => ({
                align: "left",
              })}
              renderTopToolbarCustomActions={() => (
                <div style={{ alignContent: "center" }}>
                  <Typography variant="poster" fontSize={26}></Typography>
                </div>
              )}
            />
          </Box>
        )}
      </Box>
    </>
  );
}

export default FacturacionSucursal;
